<template>
  
  <div class="border-pink-800 border-4 my-1 px-2 py-1 mx-2 lg:py-2 lg:mx-4 lg:px-4 mt-2 lg:mt-4 rounded lg:rounded-lg
  text-xs lg:text-md" :class="{'bg-green-400': joined, 'bg-red-100': !joined}">

      <div class="flex justify-between items-end">

        <div>

            <div class="w-full flex justify-start">
                <button @click="showClassPage(membership.class)"
                    class="w-24 lg:w-48 ml-2 lg:ml-10 lg:rounded-lg rounded bg-pink-500 text-white 
                    lg:text-lg font-bold h-6 lg:h-12
                    uppercase border-blue-500 border text-center">
                <label>{{$t('sessions.classPage')}}</label></button>
            </div>
        </div>

        <div>

            <div class="w-full flex justify-start">
                <button @click="openOneMembershipMapModal(membership)"
                    class="w-16 lg:w-32 ml-2 h-6 lg:h-12 lg:ml-10 lg:rounded-lg rounded bg-blue-400 text-white
                    lg:text-lg font-bold
                    uppercase border-blue-500 border text-center"
                    >
                <label>{{$t('sessions.map')}}</label></button>
            </div>
        </div>
        
        <div v-if="!hideShrink">
            
            <!-- to do undo-disabled-->
            <div class="w-full flex justify-end">
                <button @click="showCard=!showCard"
                    class="w-24 lg:w-48 ml-2 lg:ml-10 lg:rounded-lg rounded bg-pink-500 text-white
                    lg:text-lg font-bold h-6 lg:h-12 uppercase border-blue-500 border text-center">
                <label v-if="showCard">{{$t('sessions.shrink')}}</label>  <label v-else>{{$t('sessions.expand')}}</label></button>
            </div>
        </div>
      </div>
      
        <div v-if="showCard && fromBooked">

            <ma-client-membership-card ref="slotCardChild" class="w-full" :tokenId="tokenId" :email="email"
            :userId="userId" :myReload="myReload" :changeCardView="changeCardView" :displayModal="displayModal"
            :membership="membership" :join="join" :index="index" :dayDate="dayDate"
            :disablePage="disablePage" :joinAgain="joinAgain" :setJoinedForBackgroundColor="setJoinedForBackgroundColor"/>
        </div>

        <div v-else-if="showCard">

            <ma-client-membership-card ref="slotCardChild" class="w-full" :tokenId="tokenId" :email="email"
            :userId="userId" :myReload="myReload" :changeCardView="changeCardView" :displayModal="displayModal"
            :membership="membership" :join="join" :index="index" :dayDate="dayDate"
            :disablePage="disablePage" :joinAgain="joinAgain" :setJoinedForBackgroundColor="setJoinedForBackgroundColor"/>
        </div>

        <div v-else>
            <ma-client-membership-info ref="slotCardChild" class="w-full" :tokenId="tokenId" :email="email"
            :userId="userId" :myReload="myReload" :changeCardView="changeCardView" :displayModal="displayModal"
            :membership="membership" :join="join" :index="index" :dayDate="dayDate"
            :disablePage="disablePage" :joinAgain="joinAgain" :setJoinedForBackgroundColor="setJoinedForBackgroundColor"/>
        </div>
  </div>
</template>


<script>    

import MaClientMembershipInfo from './MAClientMembershipInfo';
import MaClientMembershipCard from './MAClientMembershipCard';
import MAClientBookedMembershipCard from './MAClientBookedMembershipCard';


export default {

    created(){

        // console.log(`#1 in ma client class card with: ${JSON.stringify(this.membership)}}`);
    },

      components:{

        MaClientMembershipInfo,
        MaClientMembershipCard,
        MAClientBookedMembershipCard
    },

    props: {

        hideShrink: false,

        openOneMembershipMapModal:{

            type: Function
        },

        fromBooked: false,

        joinAgain:{

            type: Function
        },
        
        showClassPage: {

            type : Function
        },

        disablePage: false,
        
        isOnline: false,

        tokenId: 0,

        email: '',

        isCard: false,
        
        userId: 0,

        dayDate: '',

        membership:{

            type: Object
        },

        businessInfo:{
      
            type: Object,
        },

        instructors:{

            type: Array 
        },

        myReload: {

            type: Function
        },

        index: 0,

        join: {
            
            type: Function
        },

        changeCardView: {

            type: Function
        },


         displayModal: {

            type: Function
        },
    },



    mounted(){

        // console.log(`in mounted`);

        this.showCard = this.isCard;
    },

    methods:{

        setJoinedForBackgroundColor(val){

            // console.log(`in setJoinedForBackgroundColor with Val: ${val}`);
            this.joined = val;
        }
    },

    data: function(){

        return{

            showCard: false,
            joined: false,
        }
    }
}
</script>

<style>

</style>